import angular from 'angular';

import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';

import { AttachmentComponent }          from './attachment.component';
import { AttachmentFileModelDirective } from './attachment.file-model.directive.ajs';
import { AttachmentsBoxComponent }      from './attachments.box.component';
import { AttachmentsSelectComponent }   from './attachments.select.component';
import { AttachmentsService }           from './attachments.service';
import { VideoLoaderDirective }         from './attachment.video-loader.directive.ajs';

angular.module('app-lite.attachments', [])
  // `file-model` stays registered while AngularJS templates still use it;
  // Angular templates bind the file input's `change` event instead.
  .directive('fileModel', AttachmentFileModelDirective)
  // `video-loader` stays registered while the standalone video page is still AngularJS.
  .directive('videoLoader', VideoLoaderDirective)
  .directive('worAttachment', downgradeComponent({ component: AttachmentComponent }) as ng.IDirectiveFactory)
  .directive('worAttachmentsBox', downgradeComponent({ component: AttachmentsBoxComponent }) as ng.IDirectiveFactory)
  .directive('worAttachmentsSelect', downgradeComponent({ component: AttachmentsSelectComponent }) as ng.IDirectiveFactory)
  .service('attachmentsApi', downgradeInjectable(AttachmentsService));
